import { mxConstants, mxGeometry } from 'mxgraph-js';

import FaultTreeVertex from '../FaultTreeVertex';
import BasicEventVertexValue from './BasicEventVertexValue';
import ReferenceTypes from '../../HCLTreeVertexValue/ReferenceTypes';
import BasicEventVertexDetailedShape from '../../../HCLCellShape/FaultTree/BasicEvent/BasicEventVertexDetailedShape';
import HCLTreeVertex from '../../HCLTreeVertex';
import BasicEventVertexDefaultShape from '../../../HCLCellShape/FaultTree/BasicEvent/BasicEventVertexDefaultShape';

class BasicEventVertex extends FaultTreeVertex {
  /**
   * @param {string} key
   * @param {BasicEventVertexValue} value
   */
  constructor(key: string, value: BasicEventVertexValue) {
    super(key, value, ReferenceTypes.BASIC_EVENTS);
  }

  getType(): string {
    return 'Basic Event';
  }

  clone(): BasicEventVertex {
    return new BasicEventVertex(null, this.value.clone());
  }

  /**
   * @override
   * @return {MxGraphType.mxGeometry}
   */
  getMyGeometry() {
    return new mxGeometry(0, 0, BasicEventVertex.SHAPE.WIDTH, BasicEventVertex.SHAPE.HEIGHT);
  }

  /**
   * @override
   * @return {[index: string]: any}
   */
  getMyStyle() {
    const style: { [index: string]: any } = {};
    style[mxConstants.STYLE_SPACING] = 6;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(148,227,196,0.2)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(73,151,140,0.65)';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FONTSIZE] = '12';
    style[mxConstants.STYLE_FONTFAMILY] = 'Roboto Condensed';
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    style[mxConstants.STYLE_OVERFLOW] = 'hidden';
    return style;
  }

  getValue(): BasicEventVertexValue {
    return super.getValue() as BasicEventVertexValue;
  }

  public updateShape(isSubLabelVisible: boolean): void {
    const style = this.getMyStyle();
    if (isSubLabelVisible) {
      style[mxConstants.STYLE_SHAPE] = BasicEventVertexDetailedShape.typeString;
      style[mxConstants.STYLE_SPACING_BOTTOM] = BasicEventVertex.SHAPE.GATE + BasicEventVertexDetailedShape.SUB_LABEL_HEIGHT;
    } else {
      style[mxConstants.STYLE_SHAPE] = BasicEventVertexDefaultShape.typeString;
      style[mxConstants.STYLE_SPACING_BOTTOM] = BasicEventVertex.SHAPE.GATE;
    }
    this.setStyle(HCLTreeVertex.mapStyles(style));
  }
}

export default BasicEventVertex;
